module.exports = __webpack_public_path__ + "img/20210828_214015.ad59f669.jpg";